module.exports = __webpack_public_path__ + "img/icon3.4eaa024f.png";